import { queryPages } from '@wix/ambassador-document-v1-page/http';
import { addMembersCustomPages } from '../utils/create-members-custom-page-data';
const PAGE_LIMIT = 100;
export const fetchPagesData = async (httpClient, errorHandler, a11yWizardAdapter) => {
  const {
    withErrorHandler
  } = errorHandler;
  const currentBranchId = await a11yWizardAdapter.getCurrentBranchId();
  const allPages = await withErrorHandler(async () => {
    let cursor;
    const queryPagesResult = [];
    do {
      var _metadata$cursors;
      const {
        data
      } = await httpClient.request(queryPages({
        branchId: currentBranchId,
        query: {
          cursorPaging: {
            cursor,
            limit: PAGE_LIMIT
          }
        }
      }));
      const {
        pages,
        metadata
      } = data;
      queryPagesResult.push(...(pages ?? []));
      cursor = (metadata == null || (_metadata$cursors = metadata.cursors) == null ? void 0 : _metadata$cursors.next) ?? undefined;
    } while (cursor);
    return queryPagesResult;
  }, {
    errorCodesMap: {}
  });
  return addMembersCustomPages(allPages, a11yWizardAdapter);
};
//# sourceMappingURL=fetch-pages-data.js.map